/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberProfileQueryResponse, GetApiBarberProfile400, GetApiBarberProfile401, GetApiBarberProfile403, GetApiBarberProfile404, GetApiBarberProfile500 } from "../entities/GetApiBarberProfile";

function getGetApiBarberProfileUrl() {
  const res = { method: 'GET', url: `/api/barber/profile` as const }
  return res
}

/**
 * @description Получить информацию о текущем мастере и статистику стрижек
 * @summary Профиль мастера
 * {@link /api/barber/profile}
 */
export async function getApiBarberProfile(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBarberProfileQueryResponse, ResponseErrorConfig<GetApiBarberProfile400 | GetApiBarberProfile401 | GetApiBarberProfile403 | GetApiBarberProfile404 | GetApiBarberProfile500>, unknown>({ method : "GET", url : getGetApiBarberProfileUrl().url.toString(), ... requestConfig })
  return res.data
}